// extracted by mini-css-extract-plugin
export default {"copyright":"Copyright_copyright__C1K5s"};